// Simplified discussion hooks - following RTKQ best practices
// Direct exports of RTKQ hooks (no unnecessary wrapper layers)

import { discussionApiSlice } from '../discussionApi';

// RTKQ hooks - direct exports
export const useSendMessageMutation = discussionApiSlice.useSendMessageMutation;
export const useEditMessageMutation = discussionApiSlice.useEditMessageMutation;
export const useDeleteMessageMutation = discussionApiSlice.useDeleteMessageMutation;
export const useToggleFollowMutation = discussionApiSlice.useToggleFollowMutation;
